<router-outlet></router-outlet>
<app-loading></app-loading>
<app-toaster-layout></app-toaster-layout>
<app-loading-signature></app-loading-signature>